export default __webpack_public_path__ + "static/media/tl4.350ed719.webp";